import { getProfile, saveProfile, deleteProfile, getProfileById, savePermissions, getPermissions, getAllPermissionsByProfile } from '../../../shared/data-services/management-profile-service';
import { updateAirportsByEmployee, getEmployeesWithAirports, getAllAirportsByEmployee, GetAllEmployeesWithAirportsByAirport, deleteAirportsByEmployee, GetAllEmployeesByAirport } from '../../../shared/data-services/management-airport-service';
import { getAirports } from '../../../shared/data-services/airport-service';
import { getEmployeesByAirport, getUserFaceFeature, saveNewUser, updateUser } from '../../../shared/data-services/talmaid-service';
import { getCompanies, getEmployeesWithCompanies, getAllEmployeesWithCompaniesByAirport, getAllEmployeesByAirport, getAllCompaniesByEmployee, UpdateCompaniesByEmployee, deleteCompaniesByEmployee } from '../../../shared/data-services/management-company-service';

export async function getAllProfile (){
  const data = await getProfile();
  return data || [ ];
};

export async function getemployeesByAirport(AirportId){
  const data = await getEmployeesByAirport(AirportId);
  return data;
}

export async function getAllAirports (companyId){
  const data = await getAirports(companyId);
  return data;
};


export async function getAirportsByEmployee (employeeId){
    const data = await getAllAirportsByEmployee(employeeId);
    return data || [ ];
  };

export async function getSelectedProfile (id){
  const data = await getProfileById(id);
  return data;
};

export async function saveSelectedProfile (id, description){
  const Profile = {
    id, 
    description
  }

  const data = await saveProfile(Profile);
  return data;
};


export async function getPermissionByProfile (profileId){
  const data = await getAllPermissionsByProfile(profileId);
  return data || [ ];
};

export async function getAllPermissions(){
  const data = await getPermissions();
  return data || [];
};



//-----------------------

export async function getAllCompanies (){
    const data = await getCompanies();
    return data;
  };

export async function getEmployees (companyId){
    const data = await getEmployeesWithCompanies(companyId);
    return data || [ ];
};

export async function getAllemployeesWithCompanies(AirportId, companyId){
  const data = await getAllEmployeesWithCompaniesByAirport(AirportId, companyId);
  return data;
}

export async function getAllEmployeesByAirportForEdit(AirportId, CompanyId){
  const data = await getAllEmployeesByAirport(AirportId, CompanyId);
  return data;
}

export async function getCompaniesByEmployee (employeeId){
  const data = await getAllCompaniesByEmployee(employeeId);
  return data || [ ];
};

export async function UpdateAllCompaniesByEmployee (companies, employee){
  await UpdateCompaniesByEmployee(companies, employee);
  return;
};

export async function deleteCompanies (id, employee){
  const data = await deleteCompaniesByEmployee(id, employee);
  return data;
};
